import { ExportButton } from '@/components/atoms/ExportButton/ExportButton';

import { useOverviewExport } from '../../hooks/useOverviewExport';

export const OverviewGlobalExport = () => {
  const { exportAll, isExporting } = useOverviewExport();

  return <ExportButton variant="outline" onExport={exportAll} isExporting={isExporting} />;
};
